/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable no-useless-escape */
/* eslint-disable security/detect-unsafe-regex */
/* eslint-disable max-len */
import React, { FC, useState, memo, useEffect } from 'react';
import { useRouter } from 'next/router';
// import { signIn } from 'next-auth/react';
import { useForm } from 'react-hook-form';
import { IconNzxtLogo, IconGoogle } from '@nzxt/react-icons';
import useUiStore, { getSetModalView } from '@stores/use-ui-store';
// import { setUserEmailCookie } from '@utils/user-email-cookie';
import Button from '@components/Button';
import ButtonLink from '@components/ButtonLink';
import Input from '@components/Input';
import Select from '@components/Select';
import CheckboxInput from '@components/CheckboxInput';
import Checkmark from '@components/Checkmark';
import Divider from '@components/Divider';
import { federatedSignIn } from '@components/Auth/LoginView/LoginView';
import {
  ROUTE_LEGAL,
  LOCATIONS,
  // ROUTE_AUTH,
  USERNAME_PATTERN_REGEX,
  ROUTE_OAUTH,
} from '@constants';
import { useTranslation as t, useFormatMessage } from '@utils/hooks';
import useSignup from '@framework/auth/use-signup';
import useCheck from '@framework/auth/use-check';
import type { SignupBody } from '@framework/api/auth';
import { getErrorMessageKey } from '@framework/utils/errors';
// import GTM from '@utils/gtm';
import * as styles from './styles';

type Props = {
  pageType: string;
  isInverted?: boolean;
};

const AcceptTermsLabel: FC = () => (
  <>
    {t('user_auth_agreement')}{' '}
    <ButtonLink
      target="_blank"
      rel="noopener noreferrer"
      href={`${process.env.NEXT_PUBLIC_ATLAS_URL}/${ROUTE_LEGAL}/terms-of-service`}
      customMargin
      className={styles.policyLink}
      noChevron
    >
      {t('user_auth_terms')}
    </ButtonLink>{' '}
    {t('user_auth_and')}{' '}
    <ButtonLink
      target="_blank"
      rel="noopener noreferrer"
      href={`${process.env.NEXT_PUBLIC_ATLAS_URL}/${ROUTE_LEGAL}/privacy-policy`}
      customMargin
      className={styles.policyLink}
      noChevron
    >
      {t('user_auth_privacy_policy')}
    </ButtonLink>
  </>
);

const SignUpView: FC<Props> = ({ pageType, isInverted }) => {
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const { query, locale } = useRouter();
  const { slug, client_id: rawClientId } = query;
  const oauthUID =
    Array.isArray(slug) && slug.length === 2 ? slug[1] : undefined;
  const clientId = Array.isArray(rawClientId) ? rawClientId[0] : rawClientId;
  const [callbackUrl, setCallbackUrl] = useState(
    pageType === 'modal'
      ? window.location.href
      : process.env.NEXT_PUBLIC_BASE_URL
  );

  const setModalView = useUiStore(getSetModalView);

  const signup = useSignup();
  const check = useCheck();
  const f = useFormatMessage();

  const {
    register,
    handleSubmit,
    getValues,
    clearErrors,
    setError,
    watch,
    formState,
    reset,
  } = useForm({
    mode: 'onBlur',
  });

  const { isDirty, isSubmitted, isSubmitting, errors } = formState;

  useEffect(() => {
    if (isDirty && isSubmitted && errors.serverError) {
      clearErrors('serverError');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDirty, isSubmitted, errors]);

  useEffect(() => {
    if (query.callbackUrl) {
      setCallbackUrl(
        Array.isArray(query.callbackUrl)
          ? query.callbackUrl[0]
          : query.callbackUrl
      );
    }
  }, [query.callbackUrl]);

  /*
  const gtmConfigAccountCreate = (): void => {
    const invalidUrl = ['/category/gaming-pcs/'];
    const validUrl = [
      '/build',
      'build/pc/',
      `/build/pc/${query}/`,
      '/build/keyboard/',
      `/build/keyboard/${query}/`,
    ];

    const isValidPath = validUrl.some(currentPage =>
      asPath.includes(currentPage)
    );
    const isInValidPath = invalidUrl.some(currentPage =>
      asPath.includes(currentPage)
    );

    if (!isValidPath) {
      return;
    }
    if (isInValidPath) {
      return;
    }
    GTM.dataLayer({
      dataLayer: {
        event: 'Config_AccountCreate',
      },
    });
  };
  */

  const onSubmit = async (data: SignupBody): Promise<void> => {
    try {
      setLoading(true);
      await signup({
        username: data.username,
        email: data.email,
        password: data.password,
        country: data.country,
        optin: data.optin,
        accept: data.accept,
        locale,
        clientId,
      });
      clearErrors();
      setLoading(false);
      // gtmConfigAccountCreate();
      setSuccessMessage(f('user_sign_up_success_verify_message'));
      // setUserEmailCookie(data.email);
    } catch ({ errors }) {
      let errorMessage = f('error_generic');
      const errorMessageKey = getErrorMessageKey(errors);
      if (errorMessageKey) {
        window.heap?.track(errorMessageKey);
        errorMessage = f(errorMessageKey);
      }
      const formValues = getValues();
      // react-hook-form doesn't support dirtySinceLastSubmit so have to reset
      reset(formValues);
      setError('serverError', {
        type: 'error',
        message: errorMessage,
      });
      setLoading(false);
    }
  };

  const USERNAME = t('label_username');

  const MESSAGE_USERNAME_INVALID = t('username_full_pattern_message');
  const MESSAGE_USERNAME_UNAVAILABLE = t('error_username_unavailable');
  const MESSAGE_INVALID_EMAIL = t('invalid_email');
  const MESSAGE_INVALID_PASSWORD = t('password_pattern_message');
  const MESSAGE_PW_MUST_MATCH = t('passwords_must_match');
  const MESSAGE_EMAIL_UNAVAILABLE = t('error_email_exists');
  const MESSAGE_MUST_ACCEPT_TOS_TERMS = t('must_accept_tos_terms');

  return (
    <div
      className={
        pageType === 'standalone'
          ? styles.standaloneWrapper(isInverted)
          : styles.loginWrapper(isInverted)
      }
    >
      <div className={styles.loginTopCard}>
        <IconNzxtLogo className={styles.logo(isInverted)} />
      </div>

      {successMessage && (
        <div className={styles.loginSuccessWrapper}>
          <div className={styles.checkMark}>
            <Checkmark />
          </div>
          <p className={styles.successMessage(isInverted)}>
            {f('user_sign_up_check_email_message')}
          </p>
          <p className={styles.successMessage(isInverted)}>{successMessage}</p>
        </div>
      )}

      {!successMessage && (
        <div className={styles.loginBottomCard}>
          <div className={styles.loginSocialSignInWrapper}>
            <Button
              type="button"
              buttonStyle="textButton"
              className={styles.loginSvgContainer}
              data-test-id="google-sign-in"
              onClick={() =>
                federatedSignIn('google', oauthUID, { callbackUrl })
              }
            >
              <IconGoogle className={styles.loginSvgStyles} />
              <span className={styles.loginSignUpWith}>
                {t('user_sign_up_text')}
              </span>
            </Button>
          </div>

          <div className={styles.loginFormWrapper}>
            <Divider
              text={t('user_email_sign_up_text')}
              isInverted={isInverted}
            />

            <form
              className={styles.loginForm}
              onSubmit={handleSubmit(onSubmit)}
              noValidate
            >
              {errors.serverError && (
                <div className={styles.errorWrapper}>
                  <p className={styles.errorMessage}>
                    {errors.serverError?.message as string}
                  </p>
                </div>
              )}
              <div>
                <Input
                  id="username"
                  type="text"
                  autoComplete="username"
                  inputLabel={USERNAME}
                  labelFor="username"
                  {...register('username', {
                    required: true,
                    // eslint-disable-next-line
                    pattern: USERNAME_PATTERN_REGEX,
                    validate: async (value: string) => {
                      if (isSubmitting) {
                        return true;
                      }
                      try {
                        const { available } = await check({ username: value });
                        return available;
                      } catch (error) {
                        // if error just validate onSubmit
                        return true;
                      }
                    },
                  })}
                  requiredError={
                    errors.username && errors.username.type === 'required'
                  }
                  patternMessage={t('username_min_length_message')}
                  patternError={
                    errors.username &&
                    errors.username.type === 'pattern' &&
                    MESSAGE_USERNAME_INVALID
                  }
                  generalError={
                    errors.username &&
                    errors.username.type === 'validate' &&
                    MESSAGE_USERNAME_UNAVAILABLE
                  }
                  isInverted={isInverted}
                />
              </div>

              <div>
                <Input
                  data-test-id="email"
                  type="email"
                  autoComplete="email"
                  inputLabel={t('label_email_address')}
                  labelFor="emailAddress"
                  {...register('email', {
                    required: true,
                    // eslint-disable-next-line
                    pattern:
                      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                    validate: async (value: string) => {
                      if (isSubmitting) {
                        return true;
                      }
                      try {
                        const { available } = await check({ email: value });
                        return available;
                      } catch (error) {
                        // if error just validate onSubmit
                        return true;
                      }
                    },
                  })}
                  requiredError={
                    errors.email && errors.email.type === 'required'
                  }
                  patternError={
                    (errors.email &&
                      errors.email.type === 'pattern' &&
                      MESSAGE_INVALID_EMAIL) ||
                    (errors.email &&
                      errors.email.type === 'validate' &&
                      MESSAGE_EMAIL_UNAVAILABLE)
                  }
                  isInverted={isInverted}
                />
              </div>

              <div>
                <Input
                  data-test-id="password"
                  type="password"
                  autoComplete="new-password"
                  inputLabel={t('label_password')}
                  labelFor="password"
                  {...register('password', {
                    required: true,
                    // eslint-disable-next-line
                    pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{6,}$/,
                  })}
                  requiredError={
                    errors.password && errors.password.type === 'required'
                  }
                  patternError={
                    errors.password &&
                    errors.password.type === 'pattern' &&
                    MESSAGE_INVALID_PASSWORD
                  }
                  patternMessage={t('password_pattern_message')}
                  isInverted={isInverted}
                />
              </div>
              <div>
                <Input
                  id="passwordConfirm"
                  type="password"
                  inputLabel={t('label_confirm_password')}
                  labelFor="passwordConfirm"
                  {...register('passwordConfirm', {
                    validate: value => value === watch('password'),
                  })}
                  patternError={
                    errors.passwordConfirm &&
                    errors.passwordConfirm.type === 'validate' &&
                    MESSAGE_PW_MUST_MATCH
                  }
                  isInverted={isInverted}
                />
              </div>

              <div>
                <Select
                  labelFor="country"
                  options={LOCATIONS}
                  selectLabel={t('label_location')}
                  {...register('country')}
                  isInverted={isInverted}
                />
              </div>

              <div className={styles.loginCheckboxWrapper}>
                <div>
                  <CheckboxInput
                    id="accept"
                    labelFor="accept"
                    checkBoxLabel={<AcceptTermsLabel />}
                    {...register('accept', {
                      required: true,
                    })}
                    requiredError={
                      errors.accept && errors.accept.type === 'required'
                    }
                    requiredMessage={MESSAGE_MUST_ACCEPT_TOS_TERMS}
                    classes={{
                      checkBoxTextClass: 'text-xs',
                    }}
                    isInverted={isInverted}
                  />
                </div>
              </div>

              <div className={styles.loginCheckboxWrapper}>
                <div className={styles.flexCenter}>
                  <CheckboxInput
                    id="optin"
                    labelFor="optin"
                    checkBoxLabel={t('user_sign_up_opt_in')}
                    {...register('optin')}
                    classes={{
                      checkBoxTextClass: 'text-xs',
                    }}
                    isInverted={isInverted}
                  />
                </div>
              </div>

              <div className={styles.loginButtonWrapper}>
                <Button
                  buttonStyle="primary"
                  type="submit"
                  loading={loading}
                  className={styles.loginButton}
                >
                  {t('user_sign_up')}
                </Button>
              </div>
            </form>
          </div>
        </div>
      )}

      <div className={styles.loginContinueWithWrapper}>
        <div className={styles.loginSignUpWrapper}>
          <p className={styles.loginSignUpText(isInverted)}>
            {t('user_have_account')}
          </p>
          {pageType === 'standalone' ? (
            <ButtonLink
              href={`/${ROUTE_OAUTH}/login`}
              className={styles.textButton}
              internalLink
            >
              {t('user_sign_in')}
            </ButtonLink>
          ) : (
            <Button
              buttonStyle="textButton"
              type="button"
              onClick={() => setModalView('LOGIN_VIEW')}
              className={styles.textButton}
            >
              {t('user_sign_in')}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default memo(SignUpView);
